// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SessionTimeout_wrapper__1PFPB","buttonsWrapper":"SessionTimeout_buttonsWrapper__2Cg61"};